import { Flex, Image, Title } from "@qws-org/ui-kit";
import type { FC } from "react";

import { useDirectus } from "~/shared/utils/directus/useDirectus";

import type { FeaturesProps } from "../Features";
import { ColumnItem } from "./ColumnItem";

export const FeaturesColumn: FC<FeaturesProps> = (props) => {
  const { data, ...rest } = props;

  const { getDirectusImage } = useDirectus();

  return (
    <Flex
      flexDirection="column"
      {...rest}
      p={{ py: 40, px: 15 }}
      md={{ p: { py: 80, ...rest.md } }}
    >
      <Title
        as="h2"
        size="medium"
        fontWeight="mobile.normal"
        lineHeight="title.mobile.large"
        horizontalAlign="center"
        m={{ mb: 48 }}
        md={{ lineHeight: "title.desktop.large" }}
        d={{ m: { mb: 64 } }}
      >
        {data.title}
      </Title>
      <Flex
        flexDirection="column"
        align="center"
        gap={48}
        d={{
          gap: 20,
          align: "flex-start",
          m: { mx: "auto", mb: 120 },

          width: "100%",
        }}
        flexWrap="wrap"
        position={{ type: "relative" }}
      >
        {data.items?.map((item) => {
          const feature = item?.feature_items_id;

          return feature && <ColumnItem key={feature.id} {...feature} />;
        })}
        {data.right_side_image?.id && (
          <Image
            width={518}
            d={{ display: "block" }}
            display="hidden"
            position={{ type: "absolute", left: 840, top: -95, zIndex: 10 }}
            value={getDirectusImage(data.right_side_image?.id ?? "", {
              format: "webp",
              width: 518,
            })}
          />
        )}
        <Image
          width={358}
          d={{ display: "block" }}
          display="hidden"
          position={{ type: "absolute", left: 1040, bottom: -44 }}
          value="/coin.png"
        />
      </Flex>
    </Flex>
  );
};
